import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M8.10859 4.75122C8.10926 4.33701 7.77403 4.00068 7.35981 4C6.9456 3.99933 6.60927 4.33456 6.60859 4.74878L6.58919 16.642L4.28843 14.2694C4.00007 13.972 3.52526 13.9647 3.22789 14.2531C2.93053 14.5414 2.92322 15.0162 3.21158 15.3136L6.79775 19.0118C6.85793 19.0739 6.92773 19.1244 7.00372 19.162C7.0489 19.1844 7.09666 19.2024 7.14643 19.2153C7.20785 19.2314 7.27158 19.2397 7.33618 19.2397C7.40036 19.2397 7.46367 19.2315 7.52472 19.2156C7.57301 19.2031 7.61941 19.186 7.6634 19.1646C7.74142 19.1268 7.81305 19.0753 7.8746 19.0118L11.4608 15.3136C11.7491 15.0162 11.7418 14.5414 11.4445 14.2531C11.1471 13.9647 10.6723 13.972 10.3839 14.2694L8.0892 16.6358L8.10859 4.75122ZM16.637 19.9343C16.2228 19.9336 15.8875 19.5973 15.8882 19.183L15.9076 7.29819L13.6124 9.66514C13.324 9.9625 12.8492 9.96981 12.5518 9.68145C12.2545 9.3931 12.2472 8.91828 12.5355 8.62092L16.1217 4.92267C16.1822 4.86025 16.2525 4.80948 16.329 4.77183C16.4294 4.72229 16.5424 4.69453 16.6618 4.69473C16.8814 4.69508 17.0789 4.78979 17.2158 4.94042L20.7847 8.62092C21.0731 8.91828 21.0658 9.3931 20.7684 9.68145C20.4711 9.96981 19.9962 9.9625 19.7079 9.66514L17.4076 7.29298L17.3882 19.1855C17.3875 19.5997 17.0512 19.9349 16.637 19.9343Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const ShortingOutlined = React.forwardRef(IconComponent);
ShortingOutlined.displayName = 'ShortingOutlined';

export { ShortingOutlined };
